<template lang="pug">
#resident-list(v-cloak)
  .box
    .box-header.with-border.register-header
      .title
        span 宛先グループの変更

    .box-body
      .list-body(v-if="groupType == 0")
        span.message 所属変更する家族ユーザーにチェックを付けて、「右に移す→」もしくは「←左に移す」ボタンで所属変更させ、最後に更新ボタンを押してください。
      .list-body(v-if="groupType == 1")
        span.message 所属変更する施設関係者ユーザーにチェックを付けて、「右に移す→」もしくは「←左に移す」ボタンで所属変更させ、最後に更新ボタンを押してください。

      .list-container.d-flex.flex-row.align-items-center.x-scroll
        .group-member-list.d-flex.flex-column
          .list-title(v-if="groupType == 0")
            span 家族ユーザー
          .list-title(v-if="groupType == 1")
            span 施設関係者ユーザー

          .list-body(v-if="groupType == 0")
            .list-body-title.d-flex.flex-row.align-items-center
              span.group-select-title 利用者グループ
              select.group-select-resident-box(v-model="selectedLeftResidentGroupId")
                option(v-for="option in residentGroupOptions" :value="option.value") {{ option.text }}
            .list-body-searchword.d-flex.flex-row.align-items-center
              b-input-group.search-filter-input-group.mr-1(size="md")
                b-input-group-prepend
                  b-input-group-text.search-filter-icon
                    .search-icon
                b-form-input.search-filter-input(v-model="leftResidentSearchWord" type="search" placeholder="検索ワードを入力してください")
              HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="resident-left-search-filter-help" title="検索項目について")
                template(v-slot:text)
                  div 検索項目は以下になります。
                  div ・利用者名
                  div ・利用者名（ふりがな）
                  div ・部屋名
                  div ・家族ユーザー名
                  div ・役割
            .list-body-line(v-if="family.display && family.registerTarget == false" v-for="family in _filteredLeftFamilies"
              :key="family.id + '-' + family.familyId").d-flex.flex-row
              b-form-checkbox(v-model="family.isTarget")
                span.target-name {{ family.familyName }}（{{ family.room }}・{{ family.name }}・{{ family.familyRelation }}
                span.target-name(v-if="family.familyPosition") ・{{family.familyPosition}}
                span.target-name ）

          .list-body(v-if="groupType == 1")
            .list-body-title.d-flex.flex-row.align-items-center
              span.group-select-title 施設関係者
              select.group-select-other-user-group-box(v-model="selectedLeftOtherUserGroupId")
                option(v-for="option in otherUserGroupOptions" :value="option.value") {{ option.text }}
            .list-body-searchword.d-flex.flex-row.align-items-center
              b-input-group.search-filter-input-group.mr-1(size="md")
                b-input-group-prepend
                  b-input-group-text.search-filter-icon
                    .search-icon
                b-form-input.search-filter-input(v-model="leftOtherUserSearchWord" type="search" placeholder="検索ワードを入力してください")
              HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="otheruser-left-search-filter-help" title="検索項目について")
                template(v-slot:text)
                  div 検索項目は以下になります。
                  div ・施設関係者ユーザー名
            .list-body-line(v-if="member.display && member.registerTarget == false" v-for="member in _filteredLeftOtherUserGroupMembers"
              :key="member.id + '-' + member.memberId").d-flex.flex-row
              b-form-checkbox(v-model="member.isTarget")
                span.target-name {{ member.memberName }}（{{ member.groupTypeName }}・{{ member.name }}）

        .move-buttons.d-flex.flex-column(v-if="groupType == 0")
          button.btn.move-right-btn(@click="moveToEditTargetFamily" type="button") 右に移す→
          button.btn.move-left-btn(@click="moveToFamily" type="button") ←左に移す
        .move-buttons.d-flex.flex-column(v-else-if="groupType == 1")
          button.btn.move-right-btn(@click="moveToEditTargetOtherUserGroupMember" type="button") 右に移す→
          button.btn.move-left-btn(@click="moveToOtherUserGroupMember" type="button") ←左に移す

        .group-member-list.d-flex.flex-column
          .list-title
            span 宛先グループ（{{ groupName }}）

          .list-body(v-if="groupType == 0")
            .list-body-title.d-flex.flex-row.align-items-center
              span.group-select-title 利用者グループ
              select.group-select-resident-box(v-model="selectedRightResidentGroupId")
                option(v-for="option in residentGroupOptions" :value="option.value") {{ option.text }}
            .list-body-searchword.d-flex.flex-row.align-items-center
              b-input-group.search-filter-input-group.mr-1(size="md")
                b-input-group-prepend
                  b-input-group-text.search-filter-icon
                    .search-icon
                b-form-input.search-filter-input(v-model="rightResidentSearchWord" type="search" placeholder="検索ワードを入力してください")
              HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="resident-right-search-filter-help" title="検索項目について")
                template(v-slot:text)
                  div 検索項目は以下になります。
                  div ・利用者名
                  div ・利用者名（ふりがな）
                  div ・部屋名
                  div ・家族ユーザー名
                  div ・役割
            .list-body-line(v-if="family.display && family.registerTarget == true" v-for="family in _filteredRightFamilies"
              :key="family.id + '-' + family.familyId").d-flex.flex-row
              b-form-checkbox(v-model="family.isTarget")
              span.target-name {{ family.familyName }}（{{ family.room }}・{{ family.name }}・{{ family.familyRelation }}
              span.target-name(v-if="family.familyPosition") ・{{family.familyPosition}}
              span.target-name ）

          .list-body(v-if="groupType == 1")
            .list-body-title.d-flex.flex-row.align-items-center
              span.group-select-title 施設関係者
              select.group-select-other-user-group-box(v-model="selectedRightOtherUserGroupId")
                option(v-for="option in otherUserGroupOptions" :value="option.value") {{ option.text }}
            .list-body-searchword.d-flex.flex-row.align-items-center
              b-input-group.search-filter-input-group.mr-1(size="md")
                b-input-group-prepend
                  b-input-group-text.search-filter-icon
                    .search-icon
                b-form-input.search-filter-input(v-model="rightOtherUserSearchWord" type="search" placeholder="検索ワードを入力してください")
              HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="otheruser-right-search-filter-help" title="検索項目について")
                template(v-slot:text)
                  div 検索項目は以下になります。
                  div ・施設関係者ユーザー名
            .list-body-line(v-if="member.display && member.registerTarget == true" v-for="member in _filteredRightOtherUserGroupMembers"
              :key="member.id + '-' + member.memberId").d-flex.flex-row
              b-form-checkbox(v-model="member.isTarget")
              span.target-name {{ member.memberName }}（{{ member.groupTypeName }}・{{ member.name }}）
      .register-row(v-show="errorMessage")
        .register-group
          .register-value
            .error-message {{ errorMessage }}

    .box-footer.with-border.register-footer
      .buttons
        button.btn.update-btn(v-if="groupType == 0" @click="confirmFamilyUpdate" type="button") 更新
        button.btn.update-btn(v-if="groupType == 1" @click="confirmOtherUserGroupMemberUpdate" type="button") 更新
        button.btn.cancel-btn(@click="gotoResidentGroupList" type="button") キャンセル

  OkCancelModal(v-model="showFamilySendMessageGroupUpdateModal" title="宛先グループの所属家族を更新しますか？" @ok="updateFamilySendMessageGroup")
  OkCancelModal(v-model="showOtherUserGroupMemberSendMessageGroupUpdateModal" title="宛先グループの所属施設関係者を更新しますか？" 
    @ok="updateOtherUserGroupMemberSendMessageGroup"
  )
  OkModal(v-model="showUpdateSuccessModal" title="更新に成功しました。" @ok="gotoResidentGroupList")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { needRefreshesStore } from "@/store/store";
import { SendMessageGroupListState, SendMessagesState } from "@/store/NeedRefreshes";

import { PcUrl } from "@/commons/constants/PcUrl";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import ResidentsService, { ResidentGetModel } from "@/commons/services/Residents";
import ResidentModel from "@/commons/models/Resident";
import FamiliesService from "@/commons/services/Families";
import OtherUserGroupsService from "@/commons/services/OtherUserGroups";
import OtherUserGroupModel from "@/commons/models/OtherUserGroup";
import OtherUserGroupMembersService from "@/commons/services/OtherUserGroupMembers";
import SendMessageGroupsService, { GroupType, SendMessageGroupsGetModel, SendMessageGroupsPatchModel } from "@/commons/services/SendMessageGroups";
import SystemError from "@/commons/models/SystemError";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";

/**
 * 施設関係者グループ一覧画面コンポーネント
 */
@Component({
  components: {
    PageLoading,
    OkCancelModal,
    OkModal,
    HelpIcon
  }
})
export default class SendMessageGroupMemberEdit extends Vue {
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;
  /** 利用者サービス */
  @Inject("ResidentsService") residentsService!: ResidentsService;
  /** 家族サービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 施設関係者グループサービス */
  @Inject("OtherUserGroupsService") otherUserGroupsService!: OtherUserGroupsService;
  /** 施設関係者グループメンバーサービス */
  @Inject("OtherUserGroupMembersService") otherUserGroupMembersService!: OtherUserGroupMembersService;
  /** 宛先グループサービス */
  @Inject("SendMessageGroupsService") sendMessageGroupsService!: SendMessageGroupsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 宛先グループの所属家族確認モーダル表示可否 */
  showFamilySendMessageGroupUpdateModal: boolean = false;
  /** 宛先グループの所属施設関係者確認モーダル表示可否 */
  showOtherUserGroupMemberSendMessageGroupUpdateModal: boolean = false;
  /** 更新完了モーダル表示可否 */
  showUpdateSuccessModal: boolean = false;

  /** 宛先グループID */
  groupId: number = 0;
  /** 宛先グループ名 */
  groupName: string = "";
  /** 宛先グループ種別 */
  groupType: GroupType = GroupType.UNKNOWN;
  /** 更新日時 */
  updated: number = 0;

  /** リスト用家族。左、右両リストの表示情報を兼ねる */
  families: Array<FamilyItemModel> = [];
  /** フィルタリング用利用者グループID(左リスト) */
  selectedLeftResidentGroupId: number = 0;
  /** フィルタリング用利用者グループID(右リスト) */
  selectedRightResidentGroupId: number = 0;
  /** フィルタリング用利用者グループリストOption */
  residentGroupOptions: Array<{ value: number; text: string }> = [];
  /** 利用者検索ワード(左リスト) */
  leftResidentSearchWord: string = "";
  /** 利用者検索ワード(右リスト) */
  rightResidentSearchWord: string = "";

  /** リスト用施設関係者。左、右両リストの表示情報を兼ねる */
  otherUserGroupMembers: Array<OtherUserGroupMemberItemModel> = [];
  /** フィルタリング用施設関係者グループID(左リスト) */
  selectedLeftOtherUserGroupId: number = 0;
  /** フィルタリング用施設関係者グループID(右リスト) */
  selectedRightOtherUserGroupId: number = 0;
  /** フィルタリング用施設関係者リストOption */
  otherUserGroupOptions: Array<{ value: number; text: string }> = [];
  /** 施設関係者グループ検索ワード(左リスト) */
  leftOtherUserSearchWord: string = "";
  /** 施設関係者グループ検索ワード(右リスト) */
  rightOtherUserSearchWord: string = "";

  /** エラーメッセージ */
  errorMessage: string = "";

  /**
   * ### フィルタリングした左リスト用家族を返す
   */
  get _filteredLeftFamilies(): Array<FamilyItemModel> {
    for (const family of this.families) {
      // 右リストにいる
      if (family.registerTarget == true) {
        continue;
      }
      // 左リストにいる
      else {
        // 利用者グループ選択肢が「全て」
        if (this.selectedLeftResidentGroupId == 0) {
          // 検索ワードが空の場合は表示対象
          if (!this.leftResidentSearchWord) {
            family.display = true;
          } else {
            // 検索ワードが該当するなら表示対象
            family.display = this.wordFilteringFamily(family, this.leftResidentSearchWord);
          }
        }
        // 利用者グループ選択肢が「全て」以外
        else {
          // 利用者グループ選択肢が該当する
          if (family.groupId == this.selectedLeftResidentGroupId) {
            // 検索ワードが空の場合は表示対象
            if (!this.leftResidentSearchWord) {
              family.display = true;
            } else {
              // 検索ワードが該当するなら表示対象
              family.display = this.wordFilteringFamily(family, this.leftResidentSearchWord);
            }
          }
          // 利用者グループ選択肢が該当しない
          else {
            family.display = false;
          }
        }
      }
    }
    return this.families;
  }

  public wordFilteringFamily(family: FamilyItemModel, searchWord: string): boolean {
    const words: string[] = this.$filterUtil.createSearchWord(searchWord);
    for (const word of words) {
      // 利用者名
      if (-1 < family.name.indexOf(word)) {
        return true;
      }
      // 利用者名（ふりがな）
      if (family.kanaName && -1 < family.kanaName.indexOf(word)) {
        return true;
      }
      // 部屋名
      if (-1 < family.room.indexOf(word)) {
        return true;
      }
      // 家族名
      if (family.familyName && -1 < family.familyName.indexOf(word)) {
        return true;
      }
      // 家族役割
      if (family.familyPosition && -1 < family.familyPosition.indexOf(word)) {
        return true;
      }
    }
    return false;
  }

  /**
   * ### フィルタリングした右リスト用家族を返す
   */
  get _filteredRightFamilies(): Array<FamilyItemModel> {
    for (const family of this.families) {
      // 左リストにいる
      if (family.registerTarget == false) {
        continue;
      }
      // 右リストにいる
      else {
        // 利用者グループ選択肢が「全て」
        if (this.selectedRightResidentGroupId == 0) {
          // 検索ワードが空の場合は表示対象
          if (!this.rightResidentSearchWord) {
            family.display = true;
          } else {
            // 検索ワードが該当するなら表示対象
            family.display = this.wordFilteringFamily(family, this.rightResidentSearchWord);
          }
        }
        // 利用者グループ選択肢が「全て」以外
        else {
          // 利用者グループ選択肢が該当する
          if (family.groupId == this.selectedRightResidentGroupId) {
            // 検索ワードが空の場合は表示対象
            if (!this.rightResidentSearchWord) {
              family.display = true;
            } else {
              // 検索ワードが該当するなら表示対象
              family.display = this.wordFilteringFamily(family, this.rightResidentSearchWord);
            }
          }
          // 利用者グループ選択肢が該当しない
          else {
            family.display = false;
          }
        }
      }
    }
    return this.families;
  }

  /**
   * ### フィルタリングした左リスト用施設関係者を返す
   */
  get _filteredLeftOtherUserGroupMembers(): Array<OtherUserGroupMemberItemModel> {
    for (const member of this.otherUserGroupMembers) {
      // 右リストにいる
      if (member.registerTarget == true) {
        continue;
      }
      // 左リストにいる
      else {
        // 施設関係者選択肢が「全て」
        if (this.selectedLeftOtherUserGroupId == 0) {
          // 検索ワードが空の場合は表示対象
          if (!this.leftOtherUserSearchWord) {
            member.display = true;
          } else {
            // 検索ワードが該当するなら表示対象
            member.display = this.wordFilteringOtherUser(member, this.leftOtherUserSearchWord);
          }
        }
        // 施設関係者選択肢が「全て」以外
        else {
          // 施設関係者選択肢が該当する
          if (member.id == this.selectedLeftOtherUserGroupId) {
            // 検索ワードが空の場合は表示対象
            if (!this.leftOtherUserSearchWord) {
              member.display = true;
            } else {
              // 検索ワードが該当するなら表示対象
              member.display = this.wordFilteringOtherUser(member, this.leftOtherUserSearchWord);
            }
          }
          // 施設関係者選択肢が該当しない
          else {
            member.display = false;
          }
        }
      }
    }
    return this.otherUserGroupMembers;
  }

  public wordFilteringOtherUser(member: OtherUserGroupMemberItemModel, searchWord: string): boolean {
    const words: string[] = this.$filterUtil.createSearchWord(searchWord);
    for (const word of words) {
      if (-1 < member.memberName.indexOf(word)) {
        return true;
      }
    }
    return false;
  }

  /**
   * ### フィルタリングした右リスト用施設関係者を返す
   */
  get _filteredRightOtherUserGroupMembers(): Array<OtherUserGroupMemberItemModel> {
    for (const member of this.otherUserGroupMembers) {
      // 左リストにいる
      if (member.registerTarget == false) {
        continue;
      }
      // 右リストにいる
      else {
        // 施設関係者選択肢が「全て」
        if (this.selectedRightOtherUserGroupId == 0) {
          // 検索ワードが空の場合は表示対象
          if (!this.rightOtherUserSearchWord) {
            member.display = true;
          } else {
            // 検索ワードが該当するなら表示対象
            member.display = this.wordFilteringOtherUser(member, this.rightOtherUserSearchWord);
          }
        }
        // 施設関係者選択肢が「全て」以外
        else {
          // 施設関係者選択肢が該当する
          if (member.id == this.selectedRightOtherUserGroupId) {
            // 検索ワードが空の場合は表示対象
            if (!this.rightOtherUserSearchWord) {
              member.display = true;
            } else {
              // 検索ワードが該当するなら表示対象
              member.display = this.wordFilteringOtherUser(member, this.rightOtherUserSearchWord);
            }
          }
          // 施設関係者選択肢が該当しない
          else {
            member.display = false;
          }
        }
      }
    }
    return this.otherUserGroupMembers;
  }

  /**
   * vue lifecycle mounted
   *
   * 画面表示情報の作成を行う
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報作成
   *
   * - グループIDをURLパラメータから格納する
   * - グループ情報を取得してグループに関連する情報を作成する
   *   - グループ名を格納する
   *   - グループフィルタリング用のセレクトボックスOptionを作成する
   * - 利用者情報を取得して各リスト用情報を作成する
   *   - 既にグループに登録されていれば右リスト用利用者(グループ登録済)へ格納する
   *   - グループに登録されていばいなければ左リスト用利用者へ格納する
   */
  public async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.groupId = Number(this.$route.params.id);

    const group: SendMessageGroupsGetModel = await this.getSendMessageGroup();
    this.groupName = group.name;
    this.groupType = group.type;
    this.updated = group.updated;

    const registerdMemberMap: Map<string, string> = new Map<string, string>();
    for (const sortKey of group.members) {
      registerdMemberMap.set(sortKey, sortKey);
    }

    if (this.groupType == GroupType.FAMILY) {
      const residentGroups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
      const residentGroupOptions: Array<{ value: number; text: string }> = this.createResidentGroupOptions(residentGroups);
      this.residentGroupOptions = residentGroupOptions;

      const residents: Array<ResidentGetModel> = await this.getResidents();
      const residentMap: Map<number, ResidentGetModel> = this.createResidentMapById(residents);

      const families: Array<FamilyItemModel> = await this.getFamilies();
      this.families = [];

      for (let family of families) {
        let familyItem: FamilyItemModel = Object.assign({}, family);
        familyItem.display = true;
        familyItem.isTarget = false;
        const resident: ResidentGetModel | undefined = residentMap.get(familyItem.id); // 家族の利用者グループIDは値不定なので利用者の情報を使用する
        familyItem.groupId = resident ? resident.groupId : familyItem.groupId;

        const sortKey: string | undefined = registerdMemberMap.get(familyItem.residentsSortKey ? familyItem.residentsSortKey : "");
        if (sortKey) {
          familyItem.registerTarget = true;
        } else {
          familyItem.registerTarget = false;
        }

        this.families.push(familyItem);
      }
    } else if ((this, this.groupType == GroupType.OTHER_USER)) {
      const otherUserGroups: Array<OtherUserGroupModel> = await this.getOtherUserGroups();
      const otherUserGroupOptions: Array<{ value: number; text: string }> = this.createOtherUserGroupOptions(otherUserGroups);
      this.otherUserGroupOptions = otherUserGroupOptions;

      const otherUserGroupMembers: Array<OtherUserGroupMemberItemModel> = await this.getOtherUserGroupMembers();
      this.otherUserGroupMembers = [];
      for (let otherUserGroupMember of otherUserGroupMembers) {
        let otherUserGroupMemberItem: OtherUserGroupMemberItemModel = Object.assign({}, otherUserGroupMember);
        otherUserGroupMemberItem.display = true;
        otherUserGroupMemberItem.isTarget = false;

        const sortKey: string | undefined = registerdMemberMap.get(otherUserGroupMemberItem.otherUserGroupsSortKey ? otherUserGroupMemberItem.otherUserGroupsSortKey : "");
        if (sortKey) {
          otherUserGroupMemberItem.registerTarget = true;
        } else {
          otherUserGroupMemberItem.registerTarget = false;
        }

        this.otherUserGroupMembers.push(otherUserGroupMemberItem);
      }
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### グループIDを指定して宛先グループを取得する
   */
  public async getSendMessageGroup(): Promise<SendMessageGroupsGetModel> {
    const response: SendMessageGroupsGetModel = await this.sendMessageGroupsService.get(userStore, Number(this.$route.params.id));
    return response;
  }

  /**
   * ### 全ての利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### 利用者グループの選択肢を作成する
   */
  public createResidentGroupOptions(residentGroups: Array<ResidentGroupsGetModel>): Array<{ value: number; text: string }> {
    const options: Array<{ value: number; text: string }> = [{ value: 0, text: "全て" }];
    for (const residentGroup of residentGroups) {
      options.push({
        value: residentGroup.id,
        text: residentGroup.name
      });
    }
    return options;
  }

  /**
   * ### 全ての利用者を取得する
   */
  public async getResidents(): Promise<Array<ResidentGetModel>> {
    let response: Array<ResidentGetModel> = [];

    try {
      response = await this.residentsService.gets(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.residentsService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number } = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat(await this.residentsService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 利用者のMAPを作成する
   */
  public createResidentMapById(residents: Array<ResidentGetModel>): Map<number, ResidentGetModel> {
    const map: Map<number, ResidentGetModel> = new Map<number, ResidentGetModel>();
    for (const resident of residents) {
      map.set(resident.id, resident);
    }
    return map;
  }

  /**
   * ### 施設にひもづく全家族を取得する
   */
  public async getFamilies(): Promise<Array<FamilyItemModel>> {
    let response: Array<FamilyItemModel> = [];

    try {
      response = (await this.familiesService.getsInFacility(userStore, { masking: "none" })) as any;
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.familiesService.getCountInFacility(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat((await this.familiesService.getsInFacility(userStore, params)) as any);
        }
      }
    }
    return response;
  }

  /**
   * ### 全ての施設関係者グループを取得する
   */
  public async getOtherUserGroups(): Promise<Array<OtherUserGroupModel>> {
    let response: Array<OtherUserGroupModel> = [];

    try {
      response = await this.otherUserGroupsService.gets(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const count: number = await this.otherUserGroupsService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / 300);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * 300,
            endIndex: i * 300 + 300
          };
          response = response.concat(await this.otherUserGroupsService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 施設関係者グループフィルタリング用のセレクトボックスOptionを作成する
   *
   * - 「全て」のOptionを用意する
   * - 施設関係者グループ名でOptionを作成する
   */
  public createOtherUserGroupOptions(groups: Array<OtherUserGroupModel>): Array<{ value: number; text: string }> {
    let options: Array<{ value: number; text: string }> = [];

    const allOption: { value: number; text: string } = { value: 0, text: "全て" };
    options.push(allOption);

    for (const group of groups) {
      const option: { value: number; text: string } = { value: group.id, text: `${group.name}` };
      options.push(option);
    }

    return options;
  }

  /**
   * ### 施設にひもづく施設関係者を取得する
   */
  public async getOtherUserGroupMembers(): Promise<Array<OtherUserGroupMemberItemModel>> {
    const families: Array<OtherUserGroupMemberItemModel> = (await this.otherUserGroupMembersService.get(userStore)) as Array<OtherUserGroupMemberItemModel>;

    return families;
  }

  /**
   * ### 利用者リストから更新対象リストに移動する
   *
   * - 移動対象ならハードコピーした利用者を更新対象リストへ格納する
   *   - 画面表示でチェックボックスのチェックをはずしたいのでisTargetをfalseにする
   * - 移動対象外ならハードコピーした利用者を新しい利用者リストへ格納する
   */
  public moveToEditTargetFamily(): void {
    let updatedFamilies: Array<FamilyItemModel> = [];

    for (const family of this.families) {
      let newFamily: FamilyItemModel = Object.assign({}, family);
      if (newFamily.isTarget && newFamily.registerTarget == false) {
        newFamily.registerTarget = true;
        newFamily.isTarget = false;
      }
      updatedFamilies.push(newFamily);
    }

    this.families = updatedFamilies;
  }

  /**
   * ### 更新対象リストから利用者リストに移動する
   *
   * - 移動対象ならハードコピーした更新対象者を利用者リストへ格納する
   *   - 画面表示でチェックボックスのチェックをはずしたいのでisTargetをfalseにする
   * - 移動対象外ならハードコピーした利用者を新しい更新対象者リストへ格納する
   */
  public moveToFamily(): void {
    let updatedFamilies: Array<FamilyItemModel> = [];

    for (const family of this.families) {
      let newFamily: FamilyItemModel = Object.assign({}, family);
      if (newFamily.isTarget && newFamily.registerTarget == true) {
        newFamily.registerTarget = false;
        newFamily.isTarget = false;
      }
      updatedFamilies.push(newFamily);
    }

    this.families = updatedFamilies;
  }

  /**
   * ### 施設関係者グループメンバーリストから更新対象リストに移動する
   *
   * - 移動対象ならハードコピーした施設関係者グループメンバーを更新対象リストへ格納する
   *   - 画面表示でチェックボックスのチェックをはずしたいのでisTargetをfalseにする
   */
  public moveToEditTargetOtherUserGroupMember(): void {
    let updatedOtherUserGroupMember: Array<OtherUserGroupMemberItemModel> = [];

    for (const otherUserGroupMember of this.otherUserGroupMembers) {
      let newOtherUserGroupMember: OtherUserGroupMemberItemModel = Object.assign({}, otherUserGroupMember);
      if (newOtherUserGroupMember.isTarget && newOtherUserGroupMember.registerTarget == false) {
        newOtherUserGroupMember.registerTarget = true;
        newOtherUserGroupMember.isTarget = false;
      }
      updatedOtherUserGroupMember.push(newOtherUserGroupMember);
    }

    this.otherUserGroupMembers = updatedOtherUserGroupMember;
  }

  /**
   * ### 更新対象リストから施設関係者グループメンバーリストに移動する
   *
   * - 移動対象ならハードコピーした更新対象者を施設関係者グループメンバーリストへ格納する
   *   - 画面表示でチェックボックスのチェックをはずしたいのでisTargetをfalseにする
   */
  public moveToOtherUserGroupMember(): void {
    let updatedOtherUserGroupMember: Array<OtherUserGroupMemberItemModel> = [];

    for (const otherUserGroupMember of this.otherUserGroupMembers) {
      let newOtherUserGroupMember: OtherUserGroupMemberItemModel = Object.assign({}, otherUserGroupMember);
      if (newOtherUserGroupMember.isTarget && newOtherUserGroupMember.registerTarget == true) {
        newOtherUserGroupMember.registerTarget = false;
        newOtherUserGroupMember.isTarget = false;
      }
      updatedOtherUserGroupMember.push(newOtherUserGroupMember);
    }

    this.otherUserGroupMembers = updatedOtherUserGroupMember;
  }

  /**
   * ### 更新確認モーダルを表示する
   */
  public confirmFamilyUpdate(): void {
    this.showFamilySendMessageGroupUpdateModal = true;

    return;
  }

  /**
   * ### 更新確認モーダルを表示する
   */
  public confirmOtherUserGroupMemberUpdate(): void {
    this.showOtherUserGroupMemberSendMessageGroupUpdateModal = true;

    return;
  }

  /**
   * ### 更新対象の利用者のグループIDを更新する
   */
  public async updateFamilySendMessageGroup(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      const updateModel: SendMessageGroupsPatchModel = this.createFamilyUpdateModel();
      await this.sendMessageGroupsService.patch(userStore, this.groupId, updateModel);

      // 宛先グループ一覧を再読み込みさせるようstoreを更新
      let sendMessageGroupList: SendMessageGroupListState = needRefreshesStore.sendMessageGroupList;
      sendMessageGroupList.sendMessageGroupList = true;
      needRefreshesStore.setSendMessageGroupList(sendMessageGroupList);
      // メッセージ送信の宛先が変更になるので再読み込みさせるようstoreを更新
      let sendMessageState: SendMessagesState = needRefreshesStore.sendMessage;
      sendMessageState.sendMessages = true;
      needRefreshesStore.setSendMessage(sendMessageState);

      // 更新成功ダイアログを表示する
      this.showUpdateSuccessModal = true;
    } catch (error) {
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 更新用model作成
   */
  public createFamilyUpdateModel(): SendMessageGroupsPatchModel {
    let members: Array<string> = [];
    for (let family of this.families) {
      if (family.registerTarget == true && family.residentsSortKey) {
        members.push(family.residentsSortKey);
      }
    }

    const model: SendMessageGroupsPatchModel = {
      name: this.groupName,
      type: this.groupType,
      members: members,
      updated: this.updated
    };

    return model;
  }

  /**
   * ### 更新対象の施設関係者のグループIDを更新する
   */
  public async updateOtherUserGroupMemberSendMessageGroup(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      const updateModel: SendMessageGroupsPatchModel = this.createOtherUserGroupMemberUpdateModel();
      await this.sendMessageGroupsService.patch(userStore, this.groupId, updateModel);

      // 宛先グループ一覧を再読み込みさせるようstoreを更新
      let sendMessageGroupList: SendMessageGroupListState = needRefreshesStore.sendMessageGroupList;
      sendMessageGroupList.sendMessageGroupList = true;
      needRefreshesStore.setSendMessageGroupList(sendMessageGroupList);
      // メッセージ送信の宛先が変更になるので再読み込みさせるようstoreを更新
      let sendMessageState: SendMessagesState = needRefreshesStore.sendMessage;
      sendMessageState.sendMessages = true;
      needRefreshesStore.setSendMessage(sendMessageState);

      // 更新成功ダイアログを表示する
      this.showUpdateSuccessModal = true;
    } catch (error) {
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 更新用model作成
   */
  public createOtherUserGroupMemberUpdateModel(): SendMessageGroupsPatchModel {
    let members: Array<string> = [];
    for (let member of this.otherUserGroupMembers) {
      if (member.registerTarget == true && member.otherUserGroupsSortKey) {
        members.push(member.otherUserGroupsSortKey);
      }
    }

    const model: SendMessageGroupsPatchModel = {
      name: this.groupName,
      type: this.groupType,
      members: members,
      updated: this.updated
    };

    return model;
  }

  /**
   * ### 宛先グループ一覧画面に遷移する
   */
  public gotoResidentGroupList(): void {
    this.$router.push(PcUrl.SendMessageGroupList);

    return;
  }
}

interface FamilyItemModel extends ResidentModel {
  isTarget: boolean;
  display: boolean;
  registerTarget: boolean;
}

interface OtherUserGroupMemberItemModel extends OtherUserGroupModel {
  isTarget: boolean;
  display: boolean;
  registerTarget: boolean;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

// 親要素からネストしてスタイルを指定する
#resident-list {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  .x-scroll {
    overflow-x: auto;
    padding: 5px;
  }

  .update-btn,
  .cancel-btn {
    width: 120px;
  }

  .message {
    margin: 5px 5px 12px 5px;
  }

  .move-buttons {
    margin: 24px;

    .move-right-btn,
    .move-left-btn {
      width: 140px;
    }
    .move-right-btn {
      margin-bottom: 12px;
    }
  }

  .list-body-searchword {
    .search-filter-input-group {
      min-width: 310px;

      .search-filter-icon {
        background-color: #fff !important;
        .search-icon {
          @include svg-icon("../../../assets/search.svg", $font-base-color, 20px, 20px);
        }
      }
      .search-filter-input {
        border-left: 0;
      }
    }
  }

  .group-member-list {
    min-width: 300px;
    width: calc(50% - 105px);
    // 縦サイズは計算して求め、出来るだけ縦サイズを大きくする
    height: calc(100vh - 291px);
    margin: 5px;

    // デフォルトフォントサイズを指定する
    font-size: 16px;
    // 外枠はここで描画させる
    border: solid 1px $border-darkgray;

    .list-title {
      padding: 5px;
      min-height: 32px;
      font-weight: bold;
      text-align: center;
      background-color: $bg-header;
      border-bottom: solid 1px $border-lightgray;
      min-height: 35px;
    }
    .list-body {
      height: calc(100vh - 300px);
      overflow-y: scroll;
      overflow-x: auto;

      .list-body-title,
      .list-body-searchword {
        height: 48px;
        background-color: $bg-header;

        .group-select-title {
          margin-right: 8px;
        }

        .group-select-resident-box {
          width: calc(100% - 120px);
          height: 34px;
          padding: 0 12px;
          border: 1px solid $form-border-color;
          border-radius: 0.25rem;
          &:focus {
            // chromeが自動的に付与するスタイルを無効化する
            outline: none;
            box-shadow: 0 0 0 0.2rem $form-boxshadow-select-color;
            border: 1px solid $form-border-select-color !important;
            border-radius: 0.25rem;
          }
        }

        .group-select-other-user-group-box {
          width: calc(100% - 98px);
          height: 34px;
          padding: 0 12px;
          border: 1px solid $form-border-color;
          border-radius: 0.25rem;
          &:focus {
            // chromeが自動的に付与するスタイルを無効化する
            outline: none;
            box-shadow: 0 0 0 0.2rem $form-boxshadow-select-color;
            border: 1px solid $form-border-select-color !important;
            border-radius: 0.25rem;
          }
        }
      }
      .target-name {
        word-break: break-all;
      }

      .list-body-title {
        padding: 8px;
      }

      .list-body-searchword,
      .list-body-line {
        padding: 8px;
        border-right: solid 1px $border-lightgray;
        border-bottom: solid 1px $border-lightgray;
      }
    }
  }
}
</style>
